import { put, call, all, select, takeLatest } from "redux-saga/effects";
import services from "../../services";

import {
  NEW_POST,
  NEW_POST_SUCCESS,
  NEW_POST_ERROR,
} from "../types/post/new-post";

import {
  GET_POST,
  GET_POST_SUCCESS,
  GET_POST_ERROR,
  RESET_GET_POST,
} from "../types/post/get-post";

import {
  GET_POSTS,
  UPDATE_GET_POSTS,
  GET_POSTS_SUCCESS,
  GET_POSTS_ERROR,
  RESET_GET_POSTS,
  GetPosts,
} from "../types/post/get-posts";

import {
  DELETE_POST_FILE,
  DELETE_POST_FILE_SUCCESS,
  DELETE_POST_FILE_ERROR,
} from "../types/post/delete-file";

import {
  DELETE_POST_MEDIA_FILE,
  DELETE_POST_MEDIA_FILE_SUCCESS,
  DELETE_POST_MEDIA_FILE_ERROR,
} from "../types/post/delete-media-file";

import {
  DELETE_POST,
  DELETE_POST_SUCCESS,
  DELETE_POST_ERROR,
} from "../types/post/delete-post";

import {
  EDIT_POST,
  EDIT_POST_SUCCESS,
  EDIT_POST_ERROR,
} from "../types/post/edit-post";

import {
  SHARE_POST_IN_TELEGRAM,
  SHARE_POST_IN_TELEGRAM_ERROR,
  SHARE_POST_IN_TELEGRAM_SUCCESS,
} from "../types/post/share-post";

import {
  SET_FEATURED_POST,
  SET_FEATURED_POST_ERROR,
  SET_FEATURED_POST_SUCCESS,
} from "../types/post/set-featured-post";

import {
  GET_LAST_POSTS,
  GET_LAST_POSTS_ERROR,
  GET_LAST_POSTS_SUCCESS,
} from "../types/post/get-last-posts";

import {
  GET_SCHEDULED_POSTS,
  GET_SCHEDULED_POSTS_ERROR,
  GET_SCHEDULED_POSTS_SUCCESS,
  UPDATE_GET_SCHEDULED_POSTS
} from "../types/post/get-scheduled-posts";

import {
  GET_FEATURED_POSTS,
  UPDATE_GET_FEATURED_POSTS,
  GET_FEATURED_POSTS_ERROR,
  GET_FEATURED_POSTS_SUCCESS,
  GetFeaturedPosts,
} from "../types/post/get-featured-posts";

import {
  GET_ALL_CATEGORIES_SUCCESS
} from "../types/category/get-all-categories"

import {
  REORDER_FEATURED_POSTS,
  REORDER_FEATURED_POSTS_ERROR,
  REORDER_FEATURED_POSTS_SUCCESS
} from "../types/post/reorder-featured-posts"

import {
  GET_POSTS_TO_REORDER,
  GET_POSTS_TO_REORDER_ERROR,
  GET_POSTS_TO_REORDER_SUCCESS
} from "../types/post/get-posts-to-reorder"

import {
  GET_RELATED_POSTS,
  GET_RELATED_POSTS_SUCCESS,
  GET_RELATED_POSTS_ERROR,
} from "../types/post/get-related-posts"



import { GetPostsOutDto, Post } from "../../types/post";

const getUserIsLoggedIn = ({ userStore }) => userStore.isLoggedIn;
const getCurrentPosts = ({ postStore }) => postStore.listPosts.data;
const getCurrentCategories = ({ categoryStore }) => categoryStore.allCategories.data;
const getCurrentScheduledPosts = ({ postStore }) => postStore.scheduledPosts.data;
const getCurrentFeaturedPosts = ({ postStore }) => postStore.featuredPosts.data;
const getCurrentPost = ({ postStore }) => postStore.post.data;
const getGroupInformation = ({ groupStore }) => groupStore.group.data;

function* newPost({ payload }): any {
  try {
    const { response, error } = yield call(services.post.newPost, payload);

    if (error) {
      yield put({ type: NEW_POST_ERROR, payload: error });
    } else {
      // const currentPostList = yield select(getCurrentPosts);
      // let postsList: { data: Post[] } = currentPostList || { data: [] };

      // if (!!postsList?.data && postsList?.data?.length > 0) {
      //   postsList.data = [...postsList?.data, response]
      // } else {
      //   postsList["data"] = [response];
      // }

      yield all([
        put({ type: NEW_POST_SUCCESS, payload: response }),
        //put({ type: UPDATE_GET_POSTS, payload: postsList })
      ])
    }
  } catch (error) {
    yield put({
      type: NEW_POST_ERROR,
      payload: "Error inexperado al crear artículo.",
    });
  }
}

function* editPost({ payload }): any {
  const post = yield select(getCurrentPost);

  try {
    const { response, error } = yield call(services.post.editPost, payload);

    if (!!error) {
      yield put({ type: EDIT_POST_ERROR, payload: error });
    } else {
      yield all([
        put({ type: EDIT_POST_SUCCESS, payload: response }),
        put({
          type: GET_POST_SUCCESS,
          payload: { ...post, ...response, group: post.group },
        }),
      ]);
    }
  } catch (error) {
    yield put({
      type: EDIT_POST_ERROR,
      payload: "No se pudo editar el Artículo",
    });
  }
}

function* setFeaturedPost({ payload }): any {
  try {
    const { response, error } = yield call(
      services.post.setFeaturedPost,
      payload
    );

    if (error) {
      yield put({ type: SET_FEATURED_POST_ERROR, payload: error });
      return;
    } else {
      // Obtener los estados actuales
      const featuredPostsList = yield select(getCurrentFeaturedPosts);
      const scheduledPostsList = yield select(getCurrentScheduledPosts);
      const postsList = yield select(getCurrentPosts);
      const currentCategories = yield select(getCurrentCategories);

      // 2. Buscar el post en todos los listados
      const findPostById = (list) =>
        list?.data?.find((post) => post.id === payload.idPost);

      const postFromPosts = findPostById(postsList);
      const postFromScheduled = findPostById(scheduledPostsList);
      const postFromFeatured = findPostById(featuredPostsList);

      let postFromCategories = null;
      if (currentCategories) {
        for (let category of currentCategories) {
          postFromCategories =
            category.last_posts?.find((post) => post.id === payload.idPost);
          if (postFromCategories) break;
        }
      }

      // 3. Determinar el post base para actualizar
      const basePost =
        postFromPosts || postFromScheduled || postFromFeatured || postFromCategories;

      const updatedPost = basePost
        ? { ...basePost, pinned: payload.pinned }
        : null;


      // 1. Actualizar postsList
      const updatedPostsList = postsList?.data?.map(post =>
        post.id === payload.idPost ? { ...post, pinned: payload.pinned } : post
      )

      // 2. Actualizar scheduledPostsList
      const updatedScheduledPostsList = scheduledPostsList?.data?.map(post =>
        post.id === payload.idPost ? { ...post, pinned: payload.pinned } : post
      )

      // 3. Actualizar featuredPostsList
      let updatedFeaturedPostsData;

      if (payload.pinned) {
        const alreadyExists = featuredPostsList?.some(post => post.id === payload.idPost);

        updatedFeaturedPostsData = alreadyExists
          ? featuredPostsList
          : [...(featuredPostsList || []), { ...updatedPost, pinned_order: featuredPostsList.length + 1 }];
      } else {
        updatedFeaturedPostsData = featuredPostsList?.filter(post => post.id !== payload.idPost) || [];
      }

      const updatedFeaturedPostsList = updatedFeaturedPostsData;

      // 4. Actualizar categorías
      const updatedCategories = currentCategories?.map(category => ({
        ...category,
        last_posts: category?.last_posts?.map(post =>
          post.id === payload.idPost ? { ...post, pinned: payload.pinned } : post
        )
      }));

      // 5. Dispatch final
      yield all([
        put({ type: SET_FEATURED_POST_SUCCESS, payload: response }),
        put({ type: UPDATE_GET_FEATURED_POSTS, payload: updatedFeaturedPostsList }),
        put({ type: UPDATE_GET_SCHEDULED_POSTS, payload: updatedScheduledPostsList }),
        put({ type: UPDATE_GET_POSTS, payload: updatedPostsList }),
        put({ type: GET_ALL_CATEGORIES_SUCCESS, payload: updatedCategories })
      ]);
    }
  } catch (err) {
    yield put({
      type: SET_FEATURED_POST_ERROR,
      payload: "No se pudo pinear el Artículo"
    });
  }
}

function* deletePost({ payload }): any {
  const posts = yield select(getCurrentPosts);
  const newListPosts = !!posts
    ? posts.filter((post) => post.id !== payload)
    : [];

  try {
    const result = yield call(services.post.deletePost, payload);
    yield all([
      put({ type: DELETE_POST_SUCCESS, payload: result }),
      put({ type: GET_POSTS_SUCCESS, payload: newListPosts }),
    ]);
  } catch (error) {
    yield put({ type: DELETE_POST_ERROR, payload: error });
  }
}

function* deleteFile({ payload }): any {
  try {
    const result = yield call(services.post.deleteFile, payload);
    yield put({ type: DELETE_POST_FILE_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: DELETE_POST_FILE_ERROR, payload: error });
  }
}

function* deleteMediaFile({ payload }): any {
  try {
    const result = yield call(services.post.deleteMediaFile, payload);
    yield put({ type: DELETE_POST_MEDIA_FILE_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: DELETE_POST_MEDIA_FILE_ERROR, payload: error });
  }
}

function* getPost({ payload }): any {
  const isLoggedIn = yield select(getUserIsLoggedIn);
  const anonymous_email = isLoggedIn ? null : localStorage.getItem("KLOUSER_SUBSCRIBER_EMAIL")
  const { response, error } = yield call(services.post.getPost, { ...payload, anonymous_email });

  if (error) {
    yield put({ type: GET_POST_ERROR, payload: error?.response?.status });
  } else {
    yield put({ type: GET_POST_SUCCESS, payload: response });
  }
}

function* getPosts({ payload }): any {
  const isLoggedIn = yield select(getUserIsLoggedIn);
  const anonymous_email = isLoggedIn ? null : localStorage.getItem("KLOUSER_SUBSCRIBER_EMAIL")
  const { response, error } = yield call(services.post.getPosts, { ...payload, anonymous_email });

  if (error) {
    yield put({ type: GET_POSTS_ERROR, payload: error.response.status });
  } else {
    yield put({
      type: GET_POSTS_SUCCESS,
      payload: response,
    });
  }
}

function* getPostsToReorder({ payload }): any {
  try {
    const { response, error } = yield call(services.post.getPosts, payload);

    if (error) {
      yield put({ type: GET_POSTS_TO_REORDER_ERROR, payload: error.response.status });
    } else {
      yield put({
        type: GET_POSTS_TO_REORDER_SUCCESS,
        payload: response,
      });
    }
  } catch (error) {
    yield put({ type: GET_POSTS_TO_REORDER_ERROR, payload: 'Error al obtener posts para reordenar' });
  }
}


function* getFeaturedPosts({ payload }): any {
  const { response, error } = yield call(
    services.post.getPosts,
    { pagination: payload.pagination, filters: { ...payload.filters, pinned: true } })

  if (error) {
    yield put({
      type: GET_FEATURED_POSTS_ERROR,
      payload: error?.response?.status,
    });
  } else {
    yield put({
      type: GET_FEATURED_POSTS_SUCCESS,
      payload: response,
    });
  }
}

function* getLastPosts({ payload }): any {
  const { response, error } = yield call(
    services.post.getPosts,
    payload)

  if (error) {
    yield put({
      type: GET_LAST_POSTS_ERROR,
      payload: error?.response?.status,
    });
  } else {
    yield put({
      type: GET_LAST_POSTS_SUCCESS,
      payload: response,
    });
  }
}

function* getScheduledPosts({ payload }: GetFeaturedPosts): any {
  const { response, error } = yield call(
    services.post.getPosts,
    { pagination: payload.pagination, filters: { ...payload.filters, published_at_null: true } }
  );

  if (error) {
    yield put({
      type: GET_SCHEDULED_POSTS_ERROR,
      payload: error?.response?.status,
    });
  } else {
    yield put({
      type: GET_SCHEDULED_POSTS_SUCCESS,
      payload: response,
    });
  }
}

function* sharePostInTelegram({ payload }): any {
  try {
    const { response, error } = yield call(
      services.post.sharePostInTelegram,
      payload
    );

    if (error) {
      yield put({
        type: SHARE_POST_IN_TELEGRAM_ERROR,
        payload: error?.response?.status,
      });
    } else {
      yield put({
        type: SHARE_POST_IN_TELEGRAM_SUCCESS,
        payload: response.length > 0 ? response : null,
      });
    }
  } catch {
    yield put({
      type: SHARE_POST_IN_TELEGRAM_ERROR,
      payload: "Error al compartir post en Telegram",
    });
  }
}

function* reorderFeaturedPosts({ payload }): any {
  try {
    const { response, error } = yield call(services.post.reorderPosts, payload);
    if (error) {
      yield put({ type: REORDER_FEATURED_POSTS_ERROR, payload: error });
    } else {
      const group = yield select(getGroupInformation);

      yield all([
        put({ type: REORDER_FEATURED_POSTS_SUCCESS, payload: response }),
        put({
          type: GET_FEATURED_POSTS, payload: {
            pagination: { _sort: 'asc', _sort_by: 'pinned_order' },
            filters: { group_id: group?.id }
          }
        }),
      ]);
    }

  } catch (error) {
    yield put({ type: REORDER_FEATURED_POSTS_ERROR, payload: 'Error al reordenar los artículos' });
  }
}

function* getRelatedPosts({ payload }): any {
  const { response, error } = yield call(services.post.getRelatedPosts, payload);

  if (error) {
    yield put({ type: GET_RELATED_POSTS_ERROR, payload: error?.response?.status || true });
  } else {
    yield put({ type: GET_RELATED_POSTS_SUCCESS, payload: response?.data || [] });
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<any>(NEW_POST, newPost);
  yield takeLatest<any>(EDIT_POST, editPost);
  yield takeLatest<any>(GET_POST, getPost);
  yield takeLatest<GetPosts>(GET_POSTS, getPosts);
  yield takeLatest<any>(DELETE_POST, deletePost);
  yield takeLatest<any>(DELETE_POST_FILE, deleteFile);
  yield takeLatest<any>(DELETE_POST_MEDIA_FILE, deleteMediaFile);
  yield takeLatest<any>(SHARE_POST_IN_TELEGRAM, sharePostInTelegram);
  yield takeLatest<any>(SET_FEATURED_POST, setFeaturedPost);
  yield takeLatest<any>(GET_FEATURED_POSTS, getFeaturedPosts);
  yield takeLatest<any>(GET_SCHEDULED_POSTS, getScheduledPosts);
  yield takeLatest<any>(GET_LAST_POSTS, getLastPosts);
  yield takeLatest<any>(REORDER_FEATURED_POSTS, reorderFeaturedPosts);
  yield takeLatest<any>(GET_POSTS_TO_REORDER, getPostsToReorder);
  yield takeLatest<any>(GET_RELATED_POSTS, getRelatedPosts);
}
